import React, { useEffect, useState } from "react";
import Navbar from "../../components/Navbar";
import Styles from "../../styles/exercise/listexercise.module.scss";
import { Link, useNavigate } from "react-router-dom";
import { adminRoutes } from "../../routers/AdminRouters";
import Create from "../../assets/session/create.png";
import Delete from "../../assets/session/delete.png";
import View from "../../assets/exersise/view.png";
import Edit from "../../assets/exersise/pencil-edit.png";
import { useDispatch, useSelector } from "react-redux";
import Close_Button from "../../assets/auth/close.png";
import Suceess from "../../assets/session/deletepopup.png";
import Swal from "sweetalert2";
import {
  deleteExercise,
  getCategory,
  getExercise,
} from "../../services/exerciseService";
import { toggle } from "../../redux";
import InfiniteScroll from "react-infinite-scroll-component";
import { FaSearch } from "react-icons/fa";

const capitalizeEachWord = (string) => {
  if (!string) return ""; // Handle empty or undefined strings
  return string
    .split(" ") // Split into words
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize each word
    .join(" "); // Join back into a string
};
const LIMIT = 15;

const ListExercise = () => {
  const { exercises } = useSelector((state) => state.exercises);
  const isSidebarOpen = useSelector((state) => state.navbar.button);
  const dispatch = useDispatch();
  const [displayedExercises, setDisplayedExercises] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [sortOrder, setSortOrder] = useState("latest");
  const handleMainContainerClick = () => {
    if (isSidebarOpen) {
      dispatch(toggle());
    }
  };
  const navigate = useNavigate();

  const fetchExercises = async (
    pageNum = page,
    query = "",
    sort = sortOrder
  ) => {
    if (loading) return;

    try {
      setLoading(true);

      const newExercises = await getExercise(
        false,
        pageNum,
        LIMIT,
        query,
        sort
      );

      if (
        newExercises &&
        Array.isArray(newExercises) &&
        newExercises.length > 0
      ) {
        setDisplayedExercises((prev) => [...prev, ...newExercises]);
        setPage((prev) => prev + 1);
        console.log("Fetched new Exercises:", newExercises.length);
      } else {
        console.log("No more Exercises to fetch");
        setHasMore(false);
      }
    } catch (error) {
      console.error("Error fetching Exercises:", error);
      setHasMore(false);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    const fetchData = () => {
      fetchExercises();
      getCategory();
    };
    fetchData();
  }, []);

  const handleSearch = async (e, sort = sortOrder) => {
    const query = e.target.value;
    setSearchQuery(query);

    try {
      if (query.trim() === "") {
        setDisplayedExercises([]);
        setPage(1);
        setHasMore(true);
        setTimeout(() => {
          fetchExercises(1, "", sort);
        }, 1);
      } else {
        const newExercises = await getExercise(false, 1, -1, query, sort);
        if (Array.isArray(newExercises)) {
          setDisplayedExercises(newExercises);
          setHasMore(false);
        }
      }
    } catch (error) {
      console.error("Search error:", error);
    }
  };

  const handleView = (exerciseId) => {
    navigate(`${adminRoutes.viewExercise.replace(":exerciseId", exerciseId)}`);
  };

  const handleEdit = (exerciseId) => {
    navigate(`${adminRoutes.editExercise.replace(":exerciseId", exerciseId)}`);
  };

  const handleDelete = (id) => {
    Swal.fire({
      html: `
        <div style="text-align: center; border-radius: 20px; position: relative;">
          <button 
            id="customCloseButton" 
            style="position: absolute; top:-5px; right:-10px; background: none; border: none; cursor: pointer;">
            <img 
              src=${Close_Button} 
              alt="Close" 
              style="width: 40px; height: 40px;"
            />
          </button>
          <img 
            src=${Suceess} 
            alt="Success" 
            style="width: 100px; margin-bottom: 10px; margin-top: 15px;" 
          />
          <h2 style="color:#151515;text-align:center;font-family:gothambold; font-size:18px;margin-bottom: 10px; ">Are you sure?</h2>
          <p style="color:#2E292A;text-align:center;font-family:gotham_bookregular; line-height:22px; font-size:14px;margin-bottom: 10px; ">
            Do you really want to delete these details? This process cannot be undone.
          </p>
          <button 
            id="cancel" 
            style="background: linear-gradient(0deg, #151515 0%, #525252 100%); color: #f3f3f6; padding: 10px 50px; font-size: 14px; font-family:gothambold; border: none; border-radius: 6px; cursor: pointer; margin-top: 10px;">
            Cancel
          </button>
          <br/>
          <button 
            id="delete" 
            style="background: #800505; color: #f3f3f6; padding: 10px 50px; font-size: 14px; font-family:gothambold; border-radius: 6px; cursor: pointer; margin-top: 10px;">
            Delete
          </button>
        </div>
      `,
      showConfirmButton: false,
      width: "400px",
      customClass: {
        popup: "custom-swal-container",
      },
      didOpen: () => {
        const cancel = document.getElementById("cancel");
        const deleteButton = document.getElementById("delete");
        const closeButton = document.getElementById("customCloseButton");

        cancel.addEventListener("click", () => {
          Swal.close();
        });
        deleteButton.addEventListener("click", async () => {
          Swal.close();
          const success = await deleteExercise(id);
          if (success) {
            window.location.reload(adminRoutes.listExercise);
          }
        });

        closeButton.addEventListener("click", () => {
          Swal.close();
        });
      },
    });
  };

  const handleCreateNewExercise = () => {
    navigate(adminRoutes.createExercise);
  };

  return (
    <>
      <Navbar />
      <div
        className={Styles.exercise_list_container_main}
        onClick={handleMainContainerClick}
      >
        <h2>
          <Link to={adminRoutes.dashboard}>HOME / </Link>{" "}
          <span>ALL EXERCISES</span>
        </h2>
        <div className={Styles.exercise_list_container}>
          <div className={Styles.table_container_heading}>
            <div className={Styles.table_container_headingone}>
              <h3>EXERCISES &nbsp;LIST</h3>
            </div>
            <div className={Styles.table_container_headingtwo}>
              <select
                className={Styles.sortselect}
                value={sortOrder}
                onChange={(e) => {
                  const selected = e.target.value;
                  setSortOrder(selected);
                  setDisplayedExercises([]);
                  setPage(1);
                  setHasMore(true);

                  if (searchQuery.trim()) {
                    handleSearch({ target: { value: searchQuery } }, selected);
                  } else {
                    fetchExercises(1, searchQuery, selected);
                  }
                }}
              >
                <option value="latest">Latest Exercise</option>
                <option value="oldest">Oldest Exercise</option>
                <option value="asc">A - Z (Sort in ascending order)</option>
                <option value="desc">Z - A (Sort in descending order)</option>
              </select>

              <div
                className={`${Styles.searchContainerchildtwo} ${
                  searchQuery ? Styles.active : ""
                }`}
              >
                <FaSearch className={Styles.searchIcon} />
                <input
                  type="text"
                  className={Styles.searchInput}
                  placeholder="Search..."
                  value={searchQuery}
                  onChange={handleSearch}
                />
              </div>
              <div
                className={Styles.create_new_session}
                onClick={handleCreateNewExercise}
                style={{ cursor: "pointer" }}
              >
                <img
                  src={Create}
                  alt="Duplicate Icon"
                  className={Styles.icon}
                />
                Create New Exercise
              </div>
            </div>
          </div>
          <div className={Styles.tableFixedHeader}>
            <div className={Styles.scrollableWrapper}>
              <table className={Styles.exercise_table}>
                <thead>
                  <tr>
                    <th style={{ width: "20%" }}>Exercise Name</th>
                    <th style={{ width: "20%" }}>Category</th>
                    <th style={{ width: "20%" }}>Type</th>
                    <th style={{ width: "20%" }}>HD Video</th>
                    <th style={{ width: "20%" }}>4k Video</th>
                    <th style={{ width: "40%" }}>Action</th>
                  </tr>
                </thead>
              </table>
              <div id="scrollableDiv" className={Styles.scrollableContainer}>
                {!displayedExercises || displayedExercises.length === 0 ? (
                  <div className={Styles.no_sessions_container}>
                    <p
                      style={{
                        textAlign: "center",
                        padding: "10px",
                        color: "#f3f3f6",
                        fontFamily: "vanguard_cf_regular",
                      }}
                    >
                      No Exercises available
                    </p>
                  </div>
                ) : (
                  <InfiniteScroll
                    dataLength={displayedExercises.length}
                    next={fetchExercises}
                    hasMore={hasMore}
                    loader={
                      <>
                      </>
                    }
                    endMessage={
                      <p style={{  textAlign: "center",
                        padding: "10px",
                        color: "#f3f3f6",
                        fontFamily: "gotham_bookregular",}}>
                      </p>
                    }
                    scrollableTarget="scrollableDiv"
                    scrollThreshold={0.8}
                  >
                    <table className={Styles.exercise_table}>
                      <tbody>
                        {displayedExercises.map((exercise) => (
                          <tr key={exercise.id}>
                            <td style={{ width: "20%" }}>
                              {capitalizeEachWord(exercise.name)}
                            </td>
                            <td style={{ width: "20%" }}>
                              {capitalizeEachWord(exercise.category.name)}
                            </td>
                            <td style={{ width: "20%" }}>
                              {capitalizeEachWord(exercise.type)}
                            </td>
                            <td style={{ width: "20%" }}>
                              {exercise.videos.primary
                                ? `${exercise.name}.${exercise.videos.primary
                                    .split(".")
                                    .pop()}`
                                : ""}
                            </td>
                            <td style={{ width: "20%" }}>
                              {exercise.videos.secondary
                                ? `${exercise.name}.${exercise.videos.secondary
                                    .split(".")
                                    .pop()}`
                                : ""}
                            </td>
                            <td style={{ width: "40%" }}>
                              <button
                                className={Styles.view_btn}
                                onClick={() => handleView(exercise._id)}
                              >
                                <img
                                  src={View}
                                  alt="View Icon"
                                  className={Styles.delete_icon}
                                />{" "}
                                View
                              </button>
                              <button
                                className={Styles.edit_btn}
                                onClick={() => handleEdit(exercise._id)}
                              >
                                <img
                                  src={Edit}
                                  alt="Edit Icon"
                                  className={Styles.delete_icon}
                                />{" "}
                                Edit
                              </button>
                              <button
                                className={Styles.delete_btn}
                                onClick={() => handleDelete(exercise._id)}
                              >
                                <img
                                  src={Delete}
                                  alt="Delete Icon"
                                  className={Styles.delete_icon}
                                />{" "}
                                Delete
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </InfiniteScroll>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ListExercise;
